var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36.75,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 36.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 5.5853,
    y1: 32.4834,
    x2: 6.0429,
    y2: 32.4834,
    gradientTransform: "translate(-316.3602 1098.2971) scale(58.5401 -32.9116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00539f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8698c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8d9ecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a3b0d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c7cee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d1d7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#bfc8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a6b3d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#94a3cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#899aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8698c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00539f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m23.9977,13.1839c-2.5248-.0039-4.9986.7102-7.133,2.0589l7.133,7.1375,7.133-7.133c-2.133-1.3523-4.6074-2.0681-7.133-2.0635Z",
    fill: "#99c8bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m23.9977,9.9583c3.3153-.0065,6.5135,1.2254,8.9677,3.4544l2.219-2.219L23.9977.0069l-11.1821,11.1867,2.2145,2.2145c2.4562-2.2251,5.6535-3.455,8.9677-3.4498Z",
    fill: "#99c8bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m11.0129,23.3c-.1358-.5312-.2366-1.0707-.302-1.6151h0c.2987-2.4064,1.2478-4.6858,2.7452-6.5931l-2.2694-2.2694L0,24.0092l11.1867,11.1821,11.1821-11.1821-7.3572-7.3617c-1.9614,1.7734-3.353,4.0884-3.9989,6.6526Z",
    fill: "#99c8bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m36.8133,12.8224l-2.2739,2.2739c1.4965,1.9043,2.4456,4.1805,2.7452,6.5839h0c-.0649.5459-.1658,1.087-.302,1.6197-.6467-2.5625-2.0382-4.8759-3.9989-6.648l-7.3572,7.3572,11.1867,11.1821,11.1867-11.1821-11.1867-11.1867Z",
    fill: "#99c8bd",
    strokeWidth: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "m37.3897,23.3503c.0012.54-.0324,1.0795-.1007,1.6151-.8906,7.3406-7.5632,12.5694-14.9039,11.6789-6.1164-.742-10.9369-5.5624-11.6789-11.6789-.0683-.5356-.1019-1.0751-.1007-1.6151.0007-.5568.0359-1.113.1052-1.6654.0653.5444.1662,1.0839.302,1.6151,1.8121,7.1713,9.0946,11.5159,16.2659,9.7038,4.7719-1.2058,8.498-4.9318,9.7038-9.7038.1358-.5312.2366-1.0707.302-1.6151.0698.5524.1049,1.1086.1052,1.6654Z",
    fill: "url(#g)",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m29.726,3.3789c-.0683-.0094-.1357-.0247-.2013-.0458-.0534-.0155-.1042-.0386-.151-.0686l-.0183-.4667h.0503c.0181.1022.0588.1991.119.2837.0492.0742.1171.1342.1967.1739.0743.0405.1579.061.2425.0595.0962.0051.1908-.0259.2654-.0869.0674-.0584.1044-.1443.1007-.2333.0022-.0811-.0273-.1599-.0824-.2196-.0753-.0706-.1662-.1223-.2654-.151l-.1464-.0549c-.1332-.0419-.2542-.1157-.3523-.215-.0826-.0913-.1268-.2109-.1235-.334-.0044-.1031.0263-.2047.0869-.2882.0624-.0811.1465-.143.2425-.1784.1142-.0419.2352-.0621.3569-.0595.1015-.0001.2027.0106.302.032.0699.0159.1364.0437.1967.0824l.0137.4255h-.0549c-.0192-.0868-.0516-.1701-.0961-.2471-.0384-.065-.0917-.1199-.1556-.1601-.0638-.0373-.1366-.0563-.2105-.0549-.0955-.0059-.1899.0234-.2654.0824-.1162.1084-.1226.2905-.0142.4067.0046.0049.0093.0096.0142.0142.0787.0647.1687.1143.2654.1464l.1418.0503c.1359.0408.2578.1184.3523.2242.0802.096.1225.2181.119.3432.0014.0811-.0175.1613-.0549.2333-.0362.0688-.0879.1284-.151.1739-.0674.05-.1434.0872-.2242.1098-.0875.0262-.1786.0386-.2699.0366-.0812.0013-.1624-.0049-.2425-.0183l.0137.0046Z",
    fill: "#00539f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m32.1281,3.0129h-.0229l.4758-1.487h.5811v.0549c-.0371.007-.0738.0161-.1098.0275-.0238.0078-.0425.0265-.0503.0503-.0105.0293-.0151.0604-.0137.0915l.0458,1.4001c-.001.0311.0037.0621.0137.0915.0093.0229.0274.041.0503.0503.036.0113.0727.0205.1098.0275v.0549h-.7321v-.0549c.0374-.0058.0741-.015.1098-.0275.0229-.0093.041-.0274.0503-.0503.0108-.0292.0139-.0607.0091-.0915l-.0412-1.4778h.0275l-.4484,1.2811-.1373.4164h-.1784l-.6222-1.7158h.0275l-.0091,1.3909c-.0026.052.0005.1042.0091.1556.0042.0322.0227.0608.0503.0778.0367.0203.0772.0327.119.0366v.0549h-.4804v-.0549c.0413-.006.0814-.0184.119-.0366.028-.0175.0478-.0455.0549-.0778.0126-.0509.0187-.1031.0183-.1556l.0458-1.2582c.0035-.0357-.0012-.0717-.0137-.1052-.0115-.025-.0287-.047-.0503-.0641-.0329-.0178-.0684-.0302-.1052-.0366v-.0549h.5673s.5307,1.487.5307,1.487Z",
    fill: "#00539f",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimumIcon);
export default __webpack_public_path__ + "static/media/optimum-icon.6cfcc030d02136350b524bc9287215e8.svg";
export { ForwardRef as ReactComponent };